import { WhatsappLogo } from "@phosphor-icons/react";

export default function WhatsAppFAB() {
    return (
        <a
            href="https://wa.me/18457295009?text=Hi%20CashFlow%20Ads%2C%20I%27d%20like%20to%20learn%20more."
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] flex items-center justify-center shadow-xl shadow-[#25D366]/30 pulse-gold"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-floating-button"
        >
            <WhatsappLogo size={30} weight="fill" color="#FFFFFF" />
        </a>
    );
}
